import React from "react";

const VisionMission = () => {
  return (
    <section className="vision-mission-section section-padding">
      <div className="container">

        {/* Section Title */}
        <div className="section-title text-center mb-5">
          <span className="subtitle">Our Vision & Mission</span>



         
        </div>

        <div className="row g-4">

          {/* Vision */}
          <div className="col-lg-6 col-md-6">
            <div className="vision-card">

              <div className="vision-icon">🚕</div>

              <h3>Our Vision</h3>

              <p>
                Our vision is to become a trusted and leading cab service provider,
                known for safe, reliable, and comfortable journeys. We aim to make
                travel easy and accessible for everyone by connecting cities with
                dependable transportation and excellent customer service.
              </p>

            </div>
          </div>

          {/* Mission */}
          <div className="col-lg-6 col-md-6">
            <div className="mission-card">

              <div className="mission-icon">🎯</div>

              <h3>Our Mission</h3>

              <p>
                Our mission is to deliver affordable, timely, and high-quality cab
                services with professional drivers and well-maintained vehicles.
                We focus on customer satisfaction, transparency, and 24/7 support
                to ensure every ride is safe, smooth, and stress-free.
              </p>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default VisionMission;